import { Button, LinkButton } from '@sorrem-client/ui/components';
import { AccessScreen } from './AccessScreen';
import { DISCORD_INVITE_URL } from './links';
import styles from './LoginPage.module.scss';

interface OAuthAccessDeniedPageProps {
    requiredRoleName: string | null;
    onRetry: () => void;
}

export function OAuthAccessDeniedPage({ requiredRoleName, onRetry }: OAuthAccessDeniedPageProps): JSX.Element {
    return (
        <AccessScreen
            ariaLabel="Access denied panel"
            kicker="Sorrem - Closed Alpha"
            title="Not in the Alpha Yet"
            subtitle={(
                <>
                    You signed in, but this Discord account doesn't have
                    {requiredRoleName ? ` the ${requiredRoleName} role` : ' the alpha tester role'} in the
                    Sorrem Discord.
                </>
            )}
        >
            <LinkButton href={DISCORD_INVITE_URL} target="_blank" rel="noopener noreferrer" className={styles.continueButton} prominent>
                Join the Discord
            </LinkButton>
            <Button className={styles.continueButton} type="button" prominent variant="secondary" onClick={onRetry}>
                I have the role now, try again
            </Button>
            <p className={styles.formNote}>
                Invites are announced in the Discord. If you were invited, check that you signed in with the
                same Discord account.
            </p>
        </AccessScreen>
    );
}
